import { render } from "./ProjectSwitchOverlay.vue?vue&type=template&id=5a9fee6e"
import script from "./ProjectSwitchOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSwitchOverlay.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectSwitchOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a9fee6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a9fee6e', __exports__)) {
    api.reload('5a9fee6e', __exports__)
  }
  
  module.hot.accept("./ProjectSwitchOverlay.vue?vue&type=template&id=5a9fee6e", () => {
    api.rerender('5a9fee6e', render)
  })

}


export default __exports__